/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { onGetClientProductMappingbyId } from "../../Store/Slices/clientProductMappingbyIdSlice";
import { onGetCategoryAll } from "../../Store/Slices/createCategorySlice";
import DesktopHeader from "./DesktopHeader";
import MobileHeader from "./MobileHeader";
import CardBalanceHeader from "./CardBalanceHeader";
import { usePlatformNavigation } from "./PlatformNavigation";
import { useHeaderCartRefresh } from "./HeaderCart";
// import { onProductByIdSubmit } from "../../Store/Slices/productSlice";

const HeaderOptimized = ({
  setModalOpen,
  showPromotionalStrip = true,
  promotionalStripPlacement = "aboveHeader",
}) => {
  const dispatch = useDispatch();
  const [scroll, setScroll] = useState(false);
  const categoryData = useSelector(
    (state) => state.userRoleSliceReducer.categoryData,
  );

  const categoryAllData = useMemo(
    () =>
      Array.isArray(categoryData)
        ? [...categoryData].sort((a, b) => a.displayOrder - b.displayOrder)
        : [],
    [categoryData],
  );
  const clientTitle = useSelector((state) => state.clientDataReducer?.title);
  const [profileMenu, setProfileMenu] = useState([]);
  const configClient = clientTitle?.trim().toLowerCase();
  // const clientProductMapping = useSelector(
  //   (state) =>
  //     state?.ClientProductMappingbyIdReducer?.data?.[0]?.clientProductMapping
  // );
  const validateLoginTokenData = useSelector(
    (state) => state.validateLoginTokenSliceReducer.data,
  );
  const loginAuthData = useSelector((state) => state.loginAuthReducer);
  const platformNav = usePlatformNavigation();
  useHeaderCartRefresh();

  const shouldDisplayInHeader = (categoryData) => {
    const visibility = String(categoryData?.visibility || "")
      .toLowerCase()
      .replace(/[^a-z]/g, "");
    if (visibility) {
      return (
        visibility === "both" ||
        visibility === "headeronly" ||
        visibility === "header" ||
        visibility.includes("header")
      );
    }
    return !!categoryData?.displayHeader;
  };

  // let category = [];
  // categoryAllData?.forEach((categoryData) => {
  //   if (categoryData.displayHeader) {
  //     let data = clientProductMapping?.find(
  //       (productData) => productData.productId === categoryData.supplierBrandId
  //     );
  //     if (data) {
  //       let products = category[categoryData.name]
  //         ? category[categoryData.name]
  //         : [];
  //       products.push(data);
  //       category = {
  //         ...category,
  //         [categoryData.name]: products,
  //       };
  //     }
  //   }
  // });
  // Memoized so DesktopHeader's nav-width measurement effect (keyed on this
  // object) only re-runs when the categories actually change.
  const category = useMemo(
    () =>
      categoryAllData?.reduce((acc, categoryData) => {
        if (shouldDisplayInHeader(categoryData)) {
          acc[categoryData.name] = categoryData;
        }
        return acc;
      }, {}),
    [categoryAllData],
  );

  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 200);
    });
    if (loginAuthData?.data?.[0]?.token) {
      // dispatch(onGetClientProductMappingbyId(sessionStorage.getItem("clientCode")));
      dispatch(onGetCategoryAll());
      // dispatch(onProductByIdSubmit(sessionStorage.getItem("clientCode")));
    }
  }, []);

  useEffect(() => {
    let isMounted = true;

    const loadProfileMenuConfig = async () => {

      if (!clientTitle) return;
      try {
        const response = await fetch(
          `/customConfig/${configClient}/profileMenu.json`,
          { cache: "no-store" }
        );
        const data = await response.json();
        data.sort((a, b) => a.displayOrder - b.displayOrder);
        const MenuItem = Array.isArray(data) ? data : [];
        setProfileMenu(MenuItem);

      }
      catch {

      }
    };

    loadProfileMenuConfig();

    return () => {
      isMounted = false;
    };
  }, [clientTitle]);

  const getInitials = (firstName = "", lastName = "") => {
    const firstLetter = firstName?.charAt(0) || "";
    const lastLetter = lastName?.charAt(0) || "";
    return `${firstLetter}${lastLetter}`.toUpperCase();
  };

  return (
    <div className="horz-move-fix">
      <DesktopHeader
        scroll={scroll}
        matchCategory={category}
        validateLoginTokenData={validateLoginTokenData}
        getInitials={getInitials}
        showPromotionalStrip={showPromotionalStrip}
        promotionalStripPlacement={promotionalStripPlacement}
        profileMenu={profileMenu}
        platformNav={platformNav}
      />
      <MobileHeader
        scroll={scroll}
        matchCategory={category}
        validateLoginTokenData={validateLoginTokenData}
        getInitials={getInitials}
        setModalOpen={setModalOpen}
        showPromotionalStrip={showPromotionalStrip}
        promotionalStripPlacement={promotionalStripPlacement}
        profileMenu={profileMenu}
        platformNav={platformNav}
      />
      <CardBalanceHeader />
    </div>
  );
};

export default HeaderOptimized;
/* eslint-enable react-hooks/exhaustive-deps */
